import { fromJS } from "immutable"
import {
  GET_SENTIMENT_WORDCLOUD_WATCHER,
  GET_SENTIMENT_WORDCLOUD_SUCCESS,
  GET_SENTIMENT_WORDCLOUD_FAILED,
  GET_QUALITATIVE_QUESTIONS_WATCHER,
  GET_QUALITATIVE_QUESTIONS_SUCCESS,
  GET_QUALITATIVE_QUESTIONS_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoadingWordcloud: true,
  totalAnswers: 0,
  words: [],
  isLoadingQuestions: true,
  questions: [],
})

function widgetQualitativeBubblesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SENTIMENT_WORDCLOUD_WATCHER:
      return state.set("isLoadingWordcloud", true)

    case GET_SENTIMENT_WORDCLOUD_SUCCESS:
      return state
        .set("isLoadingWordcloud", false)
        .set("totalAnswers", action.payload.total_answers || 0)
        .set("words", action.payload.data || [])

    case GET_SENTIMENT_WORDCLOUD_FAILED:
      return state
        .set("isLoadingWordcloud", false)
        .set("totalAnswers", 0)
        .set("words", [])

    case GET_QUALITATIVE_QUESTIONS_WATCHER:
      return state.set("isLoadingQuestions", true)

    case GET_QUALITATIVE_QUESTIONS_SUCCESS:
      return state
        .set("isLoadingQuestions", false)
        .set("questions", action.payload)

    case GET_QUALITATIVE_QUESTIONS_FAILED:
      return state.set("isLoadingQuestions", false).set("questions", [])

    default:
      return state
  }
}

export default widgetQualitativeBubblesReducer
